export class NotificationPreference {

	target: string
	userId?: string
	enabled?: boolean
	tenantId?: string
	type: NotificationType

	constructor(source?: NotificationPreference) {
		if (source) {
			Object.assign(this, source)
		}
	}

	static ofPush(target: string, tenantId?: string, enabled?: boolean): NotificationPreference {
		return new NotificationPreference({
			target,
			enabled,
			tenantId,
			type: NotificationType.PUSH
		})
	}
}

export enum NotificationType {
	SMS = 1, EMAIL = 2, PUSH = 3
}
